import {
  Clock,
  MessageSquare,
  CheckCircle2,
  Send,
  XCircle,
  Settings,
  MessageCircle,
  type LucideIcon,
} from 'lucide-react';

export type VideoStatusV10 =
  | 'in_production'
  | 'to_validate'
  | 'in_discussion'
  | 'to_publish'
  | 'published'
  | 'refused'
  | 'feedback_sent';

export type StatusCategory = 'pending' | 'success' | 'error' | 'info';

export interface VideoStatusConfig {
  label: string;
  pillClassName: string;
  dotClassName: string;
  icon: LucideIcon;
  category: StatusCategory;
}

const STATUS_MAP: Record<VideoStatusV10, VideoStatusConfig> = {
  to_validate: {
    label: 'À valider',
    pillClassName:
      'bg-[hsl(var(--v10-status-pending)/.12)] text-[hsl(var(--v10-status-pending))]',
    dotClassName: 'bg-[hsl(var(--v10-status-pending))]',
    icon: Clock,
    category: 'pending',
  },
  in_discussion: {
    label: 'En discussion',
    pillClassName:
      'bg-[hsl(var(--v10-status-pending)/.12)] text-[hsl(var(--v10-status-pending))]',
    dotClassName: 'bg-[hsl(var(--v10-status-pending))]',
    icon: MessageSquare,
    category: 'pending',
  },
  to_publish: {
    label: 'À publier',
    pillClassName:
      'bg-[hsl(var(--v10-status-success)/.12)] text-[hsl(var(--v10-status-success))]',
    dotClassName: 'bg-[hsl(var(--v10-status-success))]',
    icon: CheckCircle2,
    category: 'success',
  },
  published: {
    label: 'Publié',
    pillClassName:
      'bg-[hsl(var(--v10-status-success)/.12)] text-[hsl(var(--v10-status-success))]',
    dotClassName: 'bg-[hsl(var(--v10-status-success))]',
    icon: Send,
    category: 'success',
  },
  refused: {
    label: 'Refusé',
    pillClassName:
      'bg-[hsl(var(--v10-status-error)/.12)] text-[hsl(var(--v10-status-error))]',
    dotClassName: 'bg-[hsl(var(--v10-status-error))]',
    icon: XCircle,
    category: 'error',
  },
  in_production: {
    label: 'En production',
    pillClassName:
      'bg-[hsl(var(--v10-text-tertiary)/.12)] text-[hsl(var(--v10-text-secondary))]',
    dotClassName: 'bg-[hsl(var(--v10-text-tertiary))]',
    icon: Settings,
    category: 'info',
  },
  feedback_sent: {
    label: 'Feedback envoyé',
    pillClassName:
      'bg-[hsl(var(--v10-text-tertiary)/.12)] text-[hsl(var(--v10-text-secondary))]',
    dotClassName: 'bg-[hsl(var(--v10-text-tertiary))]',
    icon: MessageCircle,
    category: 'info',
  },
};

export function getVideoStatusConfig(
  status: string | undefined,
): VideoStatusConfig {
  return STATUS_MAP[(status as VideoStatusV10)] ?? STATUS_MAP.in_production;
}
